import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DiscountModel } from '../../../../../../../core/e-commerce/promotions/discount.model';
import { DiscountsService } from '../../../../../../../core/e-commerce/promotions/discounts.service';
import { ProductModel } from '../../../../../../../core/e-commerce/products/product.model';
import { FormControl } from '@angular/forms';
import { ProductsService } from '../../../../../../../core/e-commerce/products/products.service';
import { QueryParamsModel } from '../../../../../../../core/_base/crud';

@Component({
  selector: 'kt-discount-product-dialog',
  templateUrl: './discount-product-dialog.component.html',
  styleUrls: ['./discount-product-dialog.component.scss'],
})
export class DiscountProductDialogComponent implements OnInit {
  suggestedProducts: ProductModel[] = [];
  private newProductId: number;
  product = new FormControl();
  private newDiscountProduct: any;
  constructor(
    public dialogRef: MatDialogRef<DiscountProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DiscountModel,
    private discountService: DiscountsService,
    private productService: ProductsService
  ) {}

  ngOnInit(): void {
    this.getDiscountProducts();
    this.product.valueChanges.subscribe((value) => {
      const queryParams = new QueryParamsModel(
        { query: value },
        null,
        null,
        0,
        10
      );
      this.productService
        .getAllPaged2(queryParams)
        .subscribe((products) => (this.suggestedProducts = products.content));
    });
  }
  selectProduct(event: any) {
    this.newDiscountProduct = {
      id: this.data.id,
      products: [
        { id: this.suggestedProducts.find((p) => p.name === event).id },
      ],
    };
  }
  saveNewDiscountProduct() {
    this.discountService
      .linkProductToDiscount(this.newDiscountProduct)
      .subscribe((res) => {
        this.getDiscountProducts();
      });
  }

  deleteProduct(item: ProductModel) {
    this.discountService
      .unlinkProduct(this.data.id, item.id)
      .subscribe((res) => {
        this.getDiscountProducts();
      });
  }
  getDiscountProducts() {
    this.discountService
      .getDiscountById(this.data.id)
      .subscribe((res) => (this.data = res));
  }
}
